
import { Card, CardContent } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface TeamMember {
  id: string;
  full_name: string;
  email: string;
}

interface TeamMemberSelectorProps {
  teamMembers: TeamMember[];
  selectedTeamMember: string;
  onTeamMemberChange: (memberId: string) => void;
  isVisible: boolean;
}

const TeamMemberSelector = ({ 
  teamMembers, 
  selectedTeamMember, 
  onTeamMemberChange, 
  isVisible 
}: TeamMemberSelectorProps) => {
  if (!isVisible) return null;

  return (
    <Card className="bg-secondary/50 border-primary/20">
      <CardContent className="p-4 py-2">
        <div className="flex items-center gap-4">
          <Label htmlFor="team-member-select" className="text-white whitespace-nowrap">
            Select Team Member:
          </Label>
          <Select value={selectedTeamMember} onValueChange={onTeamMemberChange}>
            <SelectTrigger className="w-[200px] bg-white text-black border-primary/20">
              <SelectValue placeholder="Choose a team member" />
            </SelectTrigger>
            <SelectContent className="bg-white text-black border-primary/20">
              {teamMembers.length === 0 ? (
                <SelectItem value="" disabled className="text-gray-500 bg-white text-black">
                  No team members found
                </SelectItem>
              ) : (
                teamMembers.map(member => (
                  <SelectItem key={member.id} value={member.id} className="bg-white text-black">
                    {member.full_name || member.email}
                  </SelectItem>
                ))
              )}
            </SelectContent>
          </Select>
        </div>
      </CardContent>
    </Card>
  );
};

export default TeamMemberSelector;
